import { render, staticRenderFns } from "./ZxFawuZhixinghuikuanTable.vue?vue&type=template&id=87650abc&"
import script from "./ZxFawuZhixinghuikuanTable.vue?vue&type=script&lang=js&"
export * from "./ZxFawuZhixinghuikuanTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports